export const UPDATE_BUS_LOCATION = "UPDATE_BUS_LOCATION";
export const UPDATE_ETA = "UPDATE_ETA";

export const GET_BUS_ETA = "GET_BUS_ETA";
export const GET_BUS_ETA_SUCCESS = "GET_BUS_ETA_SUCCESS";
export const UPDATE_LOCATION_LIST = "UPDATE_LOCATION_LIST";
